var exports = {
  "N": "xcc377c0b--65f44b--card",
};

module.exports = exports;
